var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.data.slug && _vm.data.slug.startsWith('https'))?_c('a',{staticClass:"lnk",attrs:{"href":_vm.data.slug}},[_vm._v("\n    "+_vm._s(_vm.data.name)+"\n  ")]):(_vm.data.slug)?_c('nuxt-link',{staticClass:"lnk",attrs:{"to":_vm.link}},[_vm._v("\n    "+_vm._s(_vm.data.name)+"\n  ")]):[_vm._v("\n    "+_vm._s(_vm.data.name)+"\n  ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }